import React, { useState } from 'react';
import Breadcrumbs from '../components/Breadcrumbs';
import { FaMapMarkerAlt, FaChurch, FaUsers, FaCalendarAlt, FaInfoCircle } from 'react-icons/fa';
import './Vicarias.css';

const Vicarias = () => {
  const [vicariaSeleccionada, setVicariaSeleccionada] = useState(null);

  const vicarias = [
    {
      id: 1,
      nombre: 'Vicaría Nuestra Señora de Las Lajas',
      nombreCorto: 'Las Lajas',
      advocacion: 'Nuestra Señora de Las Lajas',
      descripcion: 'Enclavada en Ipiales, ciudad fronteriza entre Colombia y Ecuador, ubicada a una altura promedio de 2.900 metros sobre el nivel del mar. La Vicaría Nuestra Señora de Las Lajas se erige como un faro de fe que ilumina a miles de fieles. Sus parroquias, predominantemente urbanas, albergan a un pueblo trabajador y devoto, cobijado bajo la protección de la Virgen de Las Lajas.',
      historia: 'Más allá de su labor religiosa, la Vicaría juega un papel crucial en la vida social y cultural de Ipiales, promoviendo el diálogo interreligioso, el desarrollo comunitario y la construcción de un futuro esperanzador en la frontera colombo-ecuatoriana.',
      parroquias: [
        { nombre: 'Parroquia San Pedro Mártir - La Catedral', ubicacion: 'Plaza 20 de Julio, Ipiales', párroco: 'Padre Julio César Coral Benavides' },
        { nombre: 'Parroquia Medalla Milagrosa', ubicacion: 'Sector central de Ipiales', párroco: 'Padre Carlos Eduardo Delgado' },
        { nombre: 'Parroquia Cristo Sacerdote', ubicacion: 'Barrios modernos de Ipiales', párroco: 'Por confirmar' },
        { nombre: 'Parroquia Jesús Sacramentado', ubicacion: 'Ipiales', párroco: 'Padre Manuel Dolores Chamorro' },
        { nombre: 'Parroquia Cristo Rey', ubicacion: 'Barrio Balcones de la Frontera, Ipiales', párroco: 'Padre Juan Alberto Chaves' }
      ],
      zonaPastoral: 'Zona Pastoral San Lorenzo (Yaramal)',
      destacada: true,
      aniversario: '60 Años'
    },
    {
      id: 2,
      nombre: 'Vicaría San Juan Bautista',
      nombreCorto: 'San Juan Bautista',
      advocacion: 'San Juan Bautista',
      descripcion: 'La Vicaría San Juan Bautista es una de las vicarías foráneas de la Diócesis de Ipiales, dedicada a San Juan Bautista, el precursor de Jesucristo. Esta vicaría agrupa varias parroquias para facilitar la coordinación pastoral y el acompañamiento cercano a las comunidades de su territorio.',
      historia: 'La Vicaría San Juan Bautista ha sido establecida como parte de la organización territorial de la Diócesis de Ipiales para brindar un mejor servicio pastoral a las comunidades de su jurisdicción.',
      parroquias: [],
      destacada: false
    },
    {
      id: 3,
      nombre: 'Vicaría San Juan María Vianney',
      nombreCorto: 'San Juan María Vianney',
      advocacion: 'San Juan María Vianney',
      descripcion: 'La Vicaría San Juan María Vianney es una de las vicarías foráneas de la Diócesis de Ipiales, dedicada a San Juan María Vianney, el santo Cura de Ars y patrono de los párrocos. Esta vicaría agrupa varias parroquias para facilitar la coordinación pastoral y el acompañamiento cercano a las comunidades de su territorio.',
      historia: 'La Vicaría San Juan María Vianney ha sido establecida como parte de la organización territorial de la Diócesis de Ipiales para brindar un mejor servicio pastoral a las comunidades de su jurisdicción.',
      parroquias: [],
      destacada: false
    },
    {
      id: 4,
      nombre: 'Vicaría San José',
      nombreCorto: 'San José',
      advocacion: 'San José',
      descripcion: 'La Vicaría San José es una de las vicarías foráneas de la Diócesis de Ipiales, dedicada a San José, esposo de la Virgen María y padre adoptivo de Jesús. Esta vicaría agrupa varias parroquias para facilitar la coordinación pastoral y el acompañamiento cercano a las comunidades de su territorio.',
      historia: 'La Vicaría San José ha sido establecida como parte de la organización territorial de la Diócesis de Ipiales para brindar un mejor servicio pastoral a las comunidades de su jurisdicción.',
      parroquias: [],
      destacada: false
    },
    {
      id: 5,
      nombre: 'Vicaría Espíritu Santo',
      nombreCorto: 'Espíritu Santo',
      advocacion: 'Espíritu Santo',
      descripcion: 'La Vicaría Espíritu Santo es una de las vicarías foráneas de la Diócesis de Ipiales, dedicada al Espíritu Santo, tercera persona de la Santísima Trinidad. Esta vicaría agrupa varias parroquias para facilitar la coordinación pastoral y el acompañamiento cercano a las comunidades de su territorio.',
      historia: 'La Vicaría Espíritu Santo ha sido establecida como parte de la organización territorial de la Diócesis de Ipiales para brindar un mejor servicio pastoral a las comunidades de su jurisdicción.',
      parroquias: [],
      destacada: false
    }
  ];

  const handleVicariaClick = (vicaria) => {
    setVicariaSeleccionada(vicariaSeleccionada?.id === vicaria.id ? null : vicaria);
  };

  return (
    <div className="vicarias-page">
      <Breadcrumbs />
      <section className="section">
        <div className="container">
          <div className="vicarias-header">
            <h1 className="page-title">Vicarías Foráneas de la Diócesis de Ipiales</h1>
            <p className="page-subtitle">
              Las vicarías foráneas son divisiones territoriales de la Diócesis que agrupan varias parroquias 
              para facilitar la coordinación pastoral y el acompañamiento cercano a las comunidades.
            </p>
          </div>

          <div className="vicarias-content">
            <div className="vicarias-grid">
              {vicarias.map((vicaria) => (
                <div 
                  key={vicaria.id} 
                  className={`vicaria-card ${vicaria.destacada ? 'destacada' : ''} ${vicariaSeleccionada?.id === vicaria.id ? 'expandida' : ''}`}
                  onClick={() => handleVicariaClick(vicaria)}
                >
                  <div className="vicaria-card-header">
                    <div className="vicaria-icon-container">
                      <FaChurch className="vicaria-icon" />
                      {vicaria.destacada && <span className="badge-aniversario">{vicaria.aniversario}</span>}
                    </div>
                    <h2>{vicaria.nombre}</h2>
                    {vicaria.advocacion && (
                      <p className="vicaria-advocacion">Dedicada a: {vicaria.advocacion}</p>
                    )}
                  </div>

                  <div className="vicaria-card-body">
                    <p className="vicaria-descripcion">{vicaria.descripcion}</p>
                    
                    {vicariaSeleccionada?.id === vicaria.id && (
                      <div className="vicaria-detalle">
                        {vicaria.historia && (
                          <div className="vicaria-seccion">
                            <h3><FaInfoCircle /> Historia</h3>
                            <p>{vicaria.historia}</p>
                          </div>
                        )}

                        {vicaria.parroquias && vicaria.parroquias.length > 0 && (
                          <div className="vicaria-seccion">
                            <h3><FaUsers /> Parroquias</h3>
                            <div className="parroquias-list">
                              {vicaria.parroquias.map((parroquia, index) => (
                                <div key={index} className="parroquia-item">
                                  <FaChurch className="parroquia-icon-small" />
                                  <div className="parroquia-info">
                                    <h4>{parroquia.nombre}</h4>
                                    {parroquia.ubicacion && (
                                      <p className="parroquia-ubicacion">
                                        <FaMapMarkerAlt /> {parroquia.ubicacion}
                                      </p>
                                    )}
                                    {parroquia.párroco && (
                                      <p className="parroquia-parroco">
                                        <strong>Párroco:</strong> {parroquia.párroco}
                                      </p>
                                    )}
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        )}

                        {vicaria.zonaPastoral && (
                          <div className="vicaria-seccion">
                            <h3><FaMapMarkerAlt /> Zona Pastoral</h3>
                            <p>{vicaria.zonaPastoral}</p>
                          </div>
                        )}
                      </div>
                    )}
                  </div>

                  <div className="vicaria-card-footer">
                    <button className="btn-ver-detalle">
                      {vicariaSeleccionada?.id === vicaria.id ? 'Ocultar detalles' : 'Ver detalles'}
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Vicarias;
